import React from 'react';
import { useNavigate } from 'react-router-dom';
import ExcludeCountriesFilter from './filters/CountriesFilter';
import CurrenciesFilter from './filters/CurrenciesFilter';
import ProjectBudget from './filters/ProjectBudget';
import ClientFilters from './filters/ClientFilters';

const ProjectFilters = () => {
  const navigate = useNavigate();

  return (
    <div className="max-w-6xl mx-auto">
      {/* Header with Back Button */}
      <div className="flex items-center gap-4 mb-8">
        <button 
              onClick={() => navigate('/dashboard/more-settings')}
              className="flex items-center justify-center"
            >
              <img src="/Icons/arrow-back.svg" alt="Back" className="w-8 h-8" />
            </button>
        <h1 className="text-3xl font-bold text-gray-900">Project Filters</h1>
      </div>

      {/* All Filters in One Page */}
      <div className="space-y-8">
        {/* Client Filters Section */}
        <div className="bg-white rounded-xl p-6 shadow-sm">
          <ClientFilters />
        </div>

        {/* Project Budget Section */}
        <div className="bg-white rounded-xl p-6 shadow-sm">
          <ProjectBudget />
        </div>

        {/* Currency Filter Section */}
        <div className="bg-white rounded-xl p-6 shadow-sm">
          <CurrenciesFilter />
        </div>

        {/* Countries Filter Section */}
        <div className="bg-white rounded-xl p-6 shadow-sm">
          <ExcludeCountriesFilter />
        </div>
      </div>
    </div>
  );
};

export default ProjectFilters;

